import * as React from 'react';
import * as ReactDOM from 'react-dom';
import EXIF from "exif-js";
import exif2css from 'exif2css';
import { withTranslation } from "react-i18next";

import styles from './style.css';
import { Fragment } from "react";
import { getSizeContain, isChrome } from '../../../../../infrastructure/helpers';
import pinchZoom from '../../../../uq-ui/helpers/pinchZoom';
import Icon from "../../../../icons/Icon";
import UiIcon from "../../../../uq-ui/components/ui-icon";

const isChromeBrowser = isChrome();

class StickersComponentsMediaPhoto extends React.PureComponent {

  _containerRef = null;

  constructor(props) {
    super(props);
    this.state = {
      exifImageStyles: { opacity: 0 },
      imageStyles: {},
      fullscreen: false,
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.converBlobUrlToBase64();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  converBlobUrlToBase64 () {
    const reader = new FileReader();
    fetch(this.props.source)
      .then(r => r.blob())
      .then((blob) => {
        reader.readAsDataURL(blob); 
        reader.onloadend = () => {
          const base64data = reader.result;
          if (this.mounted) { this.setState({ source: base64data}); }  
        }
      });
  }

  onImageClick = () => {
    if (!this.state.fullscreen) { this.setState({ fullscreen: true }); }
  };

  onFullscreenCloseClick = () => {
    this.setState({ fullscreen: false });
  };

  // With a `maxHeight` prop the box takes the photo's own shape at full
  // width, up to maxHeight (px), instead of a fixed height.
  rememberAspect(image) {
    if (this.props.maxHeight && image.naturalWidth && image.naturalHeight && !this.state.fullscreen) {
      this.setState({ aspect: image.naturalHeight / image.naturalWidth });
    }
  }

  fitHeight() {
    const { maxHeight } = this.props;
    const width = (this._containerRef && this._containerRef.offsetWidth) || window.innerWidth;
    return this.state.aspect ? Math.min(Math.round(width * this.state.aspect), maxHeight) : maxHeight;
  }

  onExifImageLoad = (event) => {
    const image = event.target;
    this.rememberAspect(image);
    EXIF.getData(image, () => {
      let exifImageStyles = { opacity: 1 };
      const orientation = EXIF.getTag(image, 'Orientation');
      if (orientation === 8 || orientation === 6) {
        const { transformStrings } = exif2css(orientation);
        exifImageStyles = { opacity: 1, transform: transformStrings.rotate, maxWidth: '250px' };
      }

      this.setState({ exifImageStyles });
    });
  };

  onImageLoad = (event) => {
    const tgt = event.target;
    this.rememberAspect(tgt);
    if (this.props.maxHeight) {
      return; // the box already has the photo's shape; CSS contain does the rest
    }
    const cnt = this._containerRef;
    const size = getSizeContain({
      width: tgt.naturalWidth,
      height: tgt.naturalHeight
    }, {
      height: cnt.offsetHeight,
      width: cnt.offsetWidth
    });
    this.setState({ imageStyles: { ...this.state.imageStyles, ...size } });
  };

  onContainerRef = (ref) => {
    this._containerRef = ref;
  };

  onFullscreenImageRef = (ref) => {
    if (ref) { pinchZoom.call(this, ref); };
  }

  _renderWithExif(source) {
    if (this.state.fullscreen) {
      let exifImageStyles = {};
      Object.assign(exifImageStyles, this.state.exifImageStyles)
      exifImageStyles.maxWidth = '100%';
      return (
        <Fragment>
          { this.state.exifImageStyles.opacity === 0 && (
            <div className={styles.loader}>{this.props.t('loading')}</div>
          ) }
          <div className={styles.fullscreenImgContainer}>
            <img src={source}
                 ref={this.onFullscreenImageRef}
                 onLoad={this.onExifImageLoad}
                 style={exifImageStyles}
                 className={styles.fullscreenImg} />
          </div>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          { this.state.exifImageStyles.opacity === 0 && (
            <div className={styles.loader}>{this.props.t('loading')}</div>
          ) }
          <img src={source}
               onLoad={this.onExifImageLoad}
               style={this.state.exifImageStyles}
               className={styles.img}
               onClick={this.onImageClick} />
        </Fragment>
      );
    }
  }

  _renderWithoutExif(source) {
    if (this.state.fullscreen) {
      return (<div className={styles.fullscreenImgContainer}>
                <img src={source}
                     ref={this.onFullscreenImageRef}
                     onLoad={this.onImageLoad}
                     className={styles.fullscreenImg} />
              </div>);
    } else {
      return (
        <img src={source}
             style={this.state.imageStyles}
             onLoad={this.onImageLoad}
             className={styles.img}
             onClick={this.onImageClick} />
      );
    }
  }
  
  _renderContent(source, bgUrl) {
    return (
      <Fragment>
        { !isChromeBrowser && this._renderWithoutExif(source) }
        { isChromeBrowser && this._renderWithExif(source) }
        {
          this.state.fullscreen &&
          <UiIcon name="close" size={28} strokeWidth={2.2} color="#252D76"
                  className={styles.fullscreenCloseBtn} onClick={this.onFullscreenCloseClick}/>
        }
        <div style={{ backgroundImage: bgUrl }} className={this.state.fullscreen ? styles.fullscreenImgBg : styles.imgBg}/>
      </Fragment>
    );
  }

  render() {
    const source = this.state.source || this.props.source;
    const bgUrl = this.state.fullscreen ? null : `url(${source})`;
    // isMemorial only changes the layout (a taller photo); colors are tokens.
    return (
      <div className={this.props.isMemorial && !this.props.maxHeight ? styles.containerTall : styles.container}
           style={this.props.maxHeight ? { height: this.fitHeight(), minHeight: 0 } : undefined}
           ref={this.onContainerRef}>
        { this.state.fullscreen
          // Fullscreen goes straight into <body>, above the page header; it
          // carries `dir` itself because the rtl-aware CSS keys off an ancestor.
          ? ReactDOM.createPortal(<div className={styles.fullscreenLayer} dir={this.props.i18n ? this.props.i18n.dir() : 'ltr'}>{this._renderContent(source, bgUrl)}</div>, document.body)
          : this._renderContent(source, bgUrl) }
      </div>
    )
  }
}

export default withTranslation('cmp-media-photo')(StickersComponentsMediaPhoto);